import { render, staticRenderFns } from "./QuoteShow.vue?vue&type=template&id=72f10a55&scoped=true&"
import script from "./QuoteShow.vue?vue&type=script&lang=js&"
export * from "./QuoteShow.vue?vue&type=script&lang=js&"
import style0 from "./QuoteShow.vue?vue&type=style&index=0&id=72f10a55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f10a55",
  null
  
)

export default component.exports